import { render, staticRenderFns } from "./UserGroupProfile.vue?vue&type=template&id=d5508530&scoped=true&"
import script from "./UserGroupProfile.vue?vue&type=script&lang=js&"
export * from "./UserGroupProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupProfile.vue?vue&type=style&index=0&id=d5508530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5508530",
  null
  
)

export default component.exports